function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
export var LoginPolicyType = /*#__PURE__*/ function(LoginPolicyType) {
    LoginPolicyType["RocketlaneAuth"] = "ROCKETLANE_AUTH";
    LoginPolicyType["MagicLink"] = "MAGIC_LINK";
    LoginPolicyType["Idp"] = "IDP";
    return LoginPolicyType;
}({});
const resourceUrl = '/accounts/idp';
const loginPolicyUrl = '/companies/authentication';
const triggerOtpUrl = 'users/trigger-otp?token=';
const validateOtpUrl = 'users/validate-otp?token=';
const samlUrl = (idpId)=>`${resourceUrl}/${idpId}`;
class IdpHttpClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getAllIdp", ()=>{
            return this.get(resourceUrl);
        }), _define_property(this, "createIdpWithSSO", (payload)=>{
            return this.post(resourceUrl, {
                ...payload,
                enabled: false
            });
        }), _define_property(this, "updateIdpWithSSO", (payload)=>{
            return this.put(resourceUrl, {
                ...payload
            });
        }), _define_property(this, "getSamlMeta", (idpId)=>{
            if (!idpId) {
                return undefined;
            }
            return this.get(`${samlUrl(idpId)}/metadata`);
        }), _define_property(this, "getSamlMetaDownload", (idpId)=>{
            return this.get(`/accounts/idp/${idpId}/metadata/download`).then((val)=>val.attachment.location);
        }), _define_property(this, "getLoginPolicy", ()=>{
            return this.get(loginPolicyUrl);
        }), _define_property(this, "updateLoginPolicy", (payload)=>{
            return this.post(loginPolicyUrl, payload);
        }), _define_property(this, "TriggerOtp", (token)=>{
            return this.post(`${triggerOtpUrl}${token}`);
        }), _define_property(this, "ValidateOtp", ({ token, payload })=>{
            return this.post(`${validateOtpUrl}${token}`, payload);
        }), _define_property(this, "deleteIdp", (idpId)=>{
            return this.delete(samlUrl(idpId));
        }), _define_property(this, "upsertIdpWithSSO", (payload)=>{
            if (payload.idpId) {
                return this.updateIdpWithSSO(payload);
            }
            return this.createIdpWithSSO(payload);
        });
    }
}
export const IdpHttpClientApi = new IdpHttpClient();
